import { Text } from "@/atoms"
import { CheckCircleOutlined, ExternalLinkOutlined } from "@/icons"
import { NotificationTemplate } from "./NotificationTemplate"

import styles from "./NotificationTemplate.module.scss"

import type { NotificationProps } from "./open-pr.types"

export const SuccessNotification = (props: NotificationProps) => (
  <NotificationTemplate
    icon={<CheckCircleOutlined className={styles.iconSuccess} />}
    text={props.getText("notifications.prTask.success.title", props)}
    buttonText={props.actions.t("general.view")}
    buttonProps={{
      type: "primary",
      icon: <ExternalLinkOutlined />,
      onClick: () => {
        if (typeof props.state.result?.url === "string")
          window.open(props.state.result.url, "_blank")
      }
    }}
  >
    <Text>
      {props.getText(
        "notifications.prTask.success.line1",
        props,
        "notifications.prTask.typeFull"
      )}
    </Text>
  </NotificationTemplate>
)
